/* eslint-disable  @typescript-eslint/no-explicit-any */
import { ILoadingPortResponse } from "../models/Other";

export function convertLoadingPort(data: any): ILoadingPortResponse[] {
  return data?.map((item: any) => ({
    id: item.id,
    name: item.name,
    order: item.order
  }))
}